export class DataCatalogRowFilterPolicyBody {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "predicate",
            "baseName": "predicate",
            "type": "DataCatalogRowExpression",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogRowFilterPolicyBody.attributeTypeMap;
    }
    constructor() {
    }
}
